export class HomeService {
  constructor(AuthService, $cookies) {
    "ngInject";

    this.authService = AuthService;
    this.$cookies = $cookies;
  }
  getFeatureObject(list) {
    // console.log(list);
    return list.map((value) => {
      return {
        featureId: value.featureId,
        displayName: value.displayName,
        iconName: value.iconName,
        route: {
          name: value.route,
        },
      };
    });
  }
  getFeatures() {
    return this.authService
      .getFeatureList()
      .then((data) => this.getFeatureObject(data));
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.service.js